import { Card } from "src/components/card";
import { CardPills } from "src/pages/ad-studio/insights/performance/view/card-pills";
import { EntityCardNoPreview } from "src/pages/ad-studio/insights/performance/view/entity-card-no-preview";
import { EntityCardPrimitive } from "src/pages/ad-studio/insights/performance/view/entity-card-primitive";
import { MetricRows } from "src/pages/ad-studio/insights/performance/view/metric-rows";
import type {
  EntityCardAction,
  AdCardState,
  EntityCardMedia,
} from "src/pages/ad-studio/insights/performance/view/types";

type EntityCardProps = Omit<AdCardState, "media"> & {
  media: EntityCardMedia;
  performAction: (action: EntityCardAction) => void;
};

export const EntityCard = ({
  name,
  media,
  pills,
  metrics,
  performAction,
}: EntityCardProps) => (
  <Card
    flex={1}
    p={0}
    overflow="hidden"
    position="relative"
    cursor="inherit"
    _groupHover={{ borderColor: "base.borderHover" }}
  >
    <EntityCardPrimitive.Media>
      <CardMedia name={name} media={media} performAction={performAction} />
      <EntityCardPrimitive.Pills>
        <CardPills pills={pills} />
      </EntityCardPrimitive.Pills>
    </EntityCardPrimitive.Media>
    <EntityCardPrimitive.Details>
      <EntityCardPrimitive.Name>{name}</EntityCardPrimitive.Name>
      <MetricRows metrics={metrics} />
    </EntityCardPrimitive.Details>
  </Card>
);

const CardMedia = ({
  name,
  media,
  performAction,
}: Pick<EntityCardProps, "name" | "media" | "performAction">) => {
  switch (media.kind) {
    case "no-media": {
      return <EntityCardNoPreview />;
    }
    case "single":
    case "carousel": {
      return (
        <EntityCardPrimitive.Root
          name={name}
          media={media}
          performAction={performAction}
        >
          <EntityCardPrimitive.Creative />
          <EntityCardPrimitive.Carousel />
        </EntityCardPrimitive.Root>
      );
    }
    default: {
      return media satisfies never;
    }
  }
};
